<div class="user-info" *ngIf="userSession">
    <div class="user-name">{{userSession.firstName}} {{userSession.lastName}}</div>
    <div class="user-roles">{{userSession.roles.join(', ')}}</div>
</div>
